import { Component } from '@angular/core'
import { ParagraphComponent } from '@spartacus/storefront'

@Component({
    selector: 'eb-about-us',
    templateUrl: './eb-about-us.component.html',
    standalone: false
})
export class EbAboutUsComponent extends ParagraphComponent {}
